module.exports = __webpack_public_path__ + "static/media/intro-background-mobile.15e5adc5.png";